<ion-button class="profileBtn-toolbar">
  <ion-icon *ngIf="!userMainImage" slot="icon-only" name="person-sharp"></ion-icon>
  <div *ngIf="userMainImage" class="profile-image-toolbar link">
    <div class="profile-image-toolbar__wrapper">
      <div class="profile-image-toolbar__wrapper--inner">
        <img [src]="userMainImage | safe: 'url'">
      </div>
    </div>
  </div>
</ion-button>